import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import Button from '../../../../components/Button'
import ButtonIcon from '../../../../features/components/Buttons/ButtonIcon'

// import { ReactComponent as PencilIcon } from '../../../../assets/icons/pencil.svg'
import { ReactComponent as CrossIcon } from '../../../../assets/icons/close.svg'

import useStyles from './styles'

const InternalAdActionButtons = ({
  className,
  approveInternalAdHandler,
  editInternalAdHandler,
  disapproveInternalAdHandler
}) => {
  const classes = useStyles()

  return (
    <div className={classnames(classes.btnsContainer, className)}>
      {/*Edit internal ad currently commented out because there might be ads from multiple ad accounts, */}
      {/*and we don't support editing internal ads from multiple ad accounts yet.*/}
      {/*<ButtonIcon*/}
      {/*  className={classnames(classes.actionBtn)}*/}
      {/*  Icon={PencilIcon}*/}
      {/*  onClick={editInternalAdHandler}*/}
      {/*  hasBorder*/}
      {/*/>*/}
      <ButtonIcon
        Icon={CrossIcon}
        className={classnames(classes.actionBtn)}
        hasBorder
        onClick={disapproveInternalAdHandler}
        danger
        colorful
      />
      <Button className={classes.approveBtn} onClick={approveInternalAdHandler} success colorful>
        Approve
      </Button>
    </div>
  )
}

InternalAdActionButtons.propTypes = {
  approveInternalAdHandler: PropTypes.func.isRequired,
  editInternalAdHandler: PropTypes.func.isRequired,
  disapproveInternalAdHandler: PropTypes.func.isRequired,
  className: PropTypes.string
}

export default InternalAdActionButtons
